import * as Yup from "yup";
import { getInitialValues } from "../../services/config";

const getSchema = () => {
    return Yup.object().shape({
        rejectionReason: Yup.string().nullable(),
    })
}

export const surveyRecordVerificationEvidenceFormInit = (surveyRecordVerification?: any) => {
    const schema = getSchema()
    const initial = surveyRecordVerification ? surveyRecordVerification : getInitialValues(schema)
    return { schema, initial }
}
